module.exports = __webpack_public_path__ + "static/img/garbage.884f1d3f.svg";